module.exports = __webpack_public_path__ + "static/img/jygd.523a1fde.png";